module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group integration_fields",
    attrs: {
      "id": "rdstation-integration"
    }
  }, [_c('label', [_vm._v("\n    " + _vm._s(_vm.$t('account.editModal.rdStation.help')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bef4966","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Account/components/mailServices/RdStation.vue
// module id = 288
// module chunks = 1